/**
 * Created by fers on 27.04.16.
 */
import Parent from './Parent.react';
import {declareEditEntity} from '../../../common/fw/MetaDataHelper.ts';

export default class HTTPAuth extends Parent {

    static handlerName = "http-auth";
    static displayName = "HTTP Authorization";

    constructor(props) {
        super(props, HTTPAuth.displayName);
    }

    collectMetaData() {
        let list = {};

        list["auth_http_user"] = {
            name: "HTTP User",
            type: "string",
            defaultValue: "",
        };

        list["auth_http_pass"] = {
            name: "HTTP Password",
            type: "string",
            defaultValue: "",
        };

        list = this.defaultMetaData(list);

        return declareEditEntity({
            entity: HTTPAuth.handlerName,
            name: HTTPAuth.displayName,
            fields: (types) => {
                return list;
            }
        });
    }
}


